import { Injectable, Signal, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AppHostService } from "../core";

/** A link the host could not open. */
export interface LinkFailure {
  /** The URL that could not be opened. */
  url: string;
  /** Increments on every failure, so that a repeated failure for the same URL is a new value. */
  sequence: number;
}

/** Holds the current link-opening failure reported by the host, for the feedback banner. */
@Injectable({ providedIn: "root" })
export class LinkFailureStore {
  private readonly _failure = signal<LinkFailure | null>(null);
  private counter = 0;

  /** The current failure, or `null` when there is nothing to report. */
  public readonly failure: Signal<LinkFailure | null> = this._failure.asReadonly();

  constructor(appHostService: AppHostService) {
    appHostService.openLinkFailed$
      .pipe(takeUntilDestroyed())
      .subscribe((url) => this._failure.set({ url, sequence: ++this.counter }));
  }

  /** Discards the current failure. */
  public dismiss(): void {
    this._failure.set(null);
  }
}
